module.exports = "/images/bg.png?65cf79db43ca599ff65c10276d4e2a71";